import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    google_analytics_key: 'G-61V0LTE18V',
    storeSeq: '',
    eventSeq: '',
    prevEventSeq: '',
    url: '',
    selectProduct: {},
    test: 'test',
    storeInfo: {},
    device: '',
    isLogin: 0,
    basketCnt: 0,
    prePay: [],
    storeSeqList: [],
    storeInfoList: [],
    addressList: [],
    detailAddrFlag: 0,
    addr1: '',
    addr2: '',
    customerName: '',
    customerPhone: '',
    customerMemo: '',
    agrees: {
      agree1: 0,
      agree2: 0,
      agree3: 0
    },
    userPhone: '',
    userData: {},
    storeDeliveryInfo: [],
    orderDetail: [],
    isLoading: false,
    commentList: [],
    preUpdateAddr: {},
    updateAddrFlag: 0,
    footFlag: 1,
    inBasket: false,
    key: '',
    title: '',
    appTotalDiscount: 0,
    kakao: false
  },
  mutations
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js